module.exports = __webpack_public_path__ + "img/gzunion_head.487e86b6.jpg";